function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 33,
  height: 23,
  rx: 3.5,
  fill: "#1F72CD",
  stroke: "#D9D9D9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.0954 8.5L2.91429 15.7467H6.72253L7.19464 14.5913H8.27378L8.74589 15.7467H12.9377V14.8649L13.3112 15.7467H15.4795L15.853 14.8462V15.7467H24.5708L25.6309 14.6213L26.6235 15.7467L31.1011 15.7561L27.91 12.1436L31.1011 8.5H26.6929L25.661 9.60463L24.6997 8.5H15.2159L14.4015 10.3704L13.568 8.5H9.76772V9.35186L9.34497 8.5H6.0954ZM6.83228 9.52905H8.68859L10.7986 14.4431V9.52905H12.8321L14.4619 13.0524L15.9639 9.52905H17.9873V14.7291H16.7561L16.746 10.6544L14.9511 14.7291H13.8498L12.0448 10.6544V14.7291H9.51202L9.03185 13.5633H6.43767L5.9585 14.728H4.60146L6.83228 9.52905ZM24.1198 9.52905H19.1136V14.726H24.0423L25.6309 13.0036L27.162 14.726H28.7626L26.4362 12.1426L28.7626 9.52905H27.2315L25.651 11.2316L24.1198 9.52905ZM7.73531 10.4089L6.88063 12.4856H8.58899L7.73531 10.4089ZM20.3499 11.555V10.6057V10.6048H23.4736L24.8366 12.1229L23.4132 13.6493H20.3499V12.613H23.081V11.555H20.3499Z",
  fill: "white"
});

var SvgAmex = function SvgAmex(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAmex, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Amex.6924d21f.svg";
export { ForwardRef as ReactComponent };